import { getPreviewCookie, normalizePreviewUrl, setPreviewCookie } from './previewCookieHelpers';

const dispatchPreviewChanged = () => window.dispatchEvent(new CustomEvent('yakit-preview-changed'));

export const setPreviewUrl = (url: string) => {
    const normalizedUrl = url ? normalizePreviewUrl(url) : '';

    setPreviewCookie(normalizedUrl);
    dispatchPreviewChanged();
};

export const getPreviewUrl = (): string => getPreviewCookie();
